interface Props {
  onContactClick: () => void;
}

const trustBadges = [
  { icon: 'pi-verified', text: 'Staatl. gepr. Techniker' },
  { icon: 'pi-shield', text: 'Unabhängige Beratung' },
  { icon: 'pi-map-marker', text: 'Vor-Ort-Service' },
];

const HeroSection = ({ onContactClick }: Props) => {
  return (
    <div className="relative overflow-hidden">
      {/* Glow blobs */}
      <div className="pointer-events-none absolute -top-20 -left-[100px] h-[500px] w-[500px] bg-[radial-gradient(circle,rgba(7,154,205,0.12)_0%,transparent_70%)]" />
      <div className="pointer-events-none absolute -bottom-[60px] -right-[60px] h-[400px] w-[400px] bg-[radial-gradient(circle,rgba(56,189,248,0.07)_0%,transparent_70%)]" />

      <div className="mx-auto max-w-[1152px] px-8 pt-[clamp(40px,7vw,80px)] pb-[clamp(48px,7vw,80px)]">
        <div className="flex flex-row flex-wrap items-center gap-[clamp(32px,6vw,72px)]">

          {/* Text */}
          <div className="flex min-w-0 flex-1 basis-[360px] flex-col gap-7">

            <div className="inline-flex w-fit">
              <span className="rounded-full border border-ak-sky/25 bg-ak-sky/10 px-3.5 py-[5px] text-xs font-semibold uppercase tracking-[0.06em] text-ak-sky">
                IT-Beratung für Zuhause
              </span>
            </div>

            <h1 className="m-0 text-[clamp(2.4rem,5vw,3.8rem)] font-bold leading-[1.1] tracking-[-0.02em] text-white">
              Technik nervt?<br />
              <span className="relative inline-block text-ak-yellow">
                Ich mach&apos;s einfach.
                <svg viewBox="0 0 300 12" className="absolute -bottom-2 left-0 h-2.5 w-full opacity-50">
                  <path d="M0 10 Q75 0 150 6 Q225 12 300 4" stroke="#fde047" strokeWidth="2.5" fill="none" strokeLinecap="round" />
                </svg>
              </span>
            </h1>

            <p className="m-0 max-w-[480px] text-[clamp(16px,2vw,18px)] leading-[1.7] text-white/75">
              Ich komme zu Ihnen nach Hause, höre zu und finde eine Lösung –
              egal ob SmartHome, WLAN oder Gerätechaos.{' '}
              <strong className="text-white">Ohne Fachchinesisch.</strong>
            </p>

            {/* Trust-Badges */}
            <div className="flex flex-wrap gap-4">
              {trustBadges.map((b, i) => (
                <div key={i} className="flex items-center gap-[7px] text-[13px] text-ak-muted">
                  <i className={`pi ${b.icon} text-sm text-ak-sky`}></i>
                  {b.text}
                </div>
              ))}
            </div>

            {/* CTAs */}
            <div className="flex flex-wrap gap-3">
              <button onClick={onContactClick} className="btn-primary font-semibold">
                <i className="pi pi-envelope"></i> Kontakt aufnehmen
              </button>
              <button
                onClick={() => {
                  const el = document.getElementById('services-section');
                  if (el) el.scrollIntoView({ behavior: 'smooth' });
                }}
                className="btn-secondary"
              >
                Leistungen ansehen <i className="pi pi-arrow-down"></i>
              </button>
            </div>
          </div>

          {/* Bild */}
          <div className="relative flex min-w-0 flex-1 basis-[280px] justify-center">
            <div className="relative w-full max-w-[400px]">
              <img
                src="/assets/hero_image.webp"
                alt="Illustration: IT-Berater erklärt einem Kunden die SmartHome-Einrichtung"
                width={800}
                height={800}
                className="block h-auto w-full rounded-[28px] shadow-[0_20px_60px_rgba(0,0,0,0.5),0_0_0_1px_rgba(56,189,248,0.15)]"
              />
              {/* Badge */}
              <div className="absolute -bottom-4 -left-4 flex items-center gap-2.5 rounded-[14px] border border-ak-sky/25 bg-ak-dark px-4 py-2.5 shadow-[0_8px_24px_rgba(0,0,0,0.4)]">
                <i className="pi pi-star-fill text-base text-ak-yellow"></i>
                <div>
                  <div className="text-[13px] font-bold text-white">Persönliche Beratung</div>
                  <div className="text-[11px] text-ak-muted">Vor Ort oder per Telefon</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
};

export default HeroSection;
